import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=20dbd4e2&scoped=true&"
import script from "./PersonalSettings.vue?vue&type=script&lang=js&"
export * from "./PersonalSettings.vue?vue&type=script&lang=js&"
import style0 from "./PersonalSettings.vue?vue&type=style&index=0&id=20dbd4e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dbd4e2",
  null
  
)

export default component.exports